// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://laxdoiwbzbisdozgmytu.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxheGRvaXdiemJpc2RvemdteXR1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTExMjA5NjgsImV4cCI6MjA2NjY5Njk2OH0.yI6eLB8Z6JjM8Ky8XHOItFUDimeAenJbe7kUNUsuers";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);